// extracted by mini-css-extract-plugin
export var standaloneTable = "_1u-0";
export var standaloneTableWithBodyFill = "_1u-1";
export var withExtraHeader = "_1u-2";